export default {
  path: '/notifications',
  name: 'notifications',
  component: () => import('../components/notification/Layout'),
  redirect: { name: 'NotificationList' },
  meta: {
    breadcrumb: 'administration.notification.notifications',
  },
  children: [
    {
      name: 'NotificationList',
      path: '',
      component: () => import('../views/notification/List'),
      meta: {
        breadcrumb: 'global.list',
      },

    },
    {
      name: 'NotificationShow',
      path: ':id',
      component: () => import('../views/notification/Show'),
      meta: {
        breadcrumb: 'administration.notification.notification',
      },
    }
  ]
};
